import { useWhatAreYouAfraidOfSamlResponse } from "@modules/mgp/queries";
import LoadingIndicator from "@common/components/LoadingIndicator";
import { useState, useCallback, useMemo } from "react";
import { MGPIFrame, Typography, useIsSafari } from "@earned/core";
import {
  MGP_SAFARI_COOKIE_FIX_URL,
  MGP_SSO_URL,
} from "@modules/mgp-sso/constants";
import { captureException } from "@sentry/nextjs";
import { SafariCookieConsent } from "../SafariCookieConsent";

const WhatAreYouAfraidOfSSO = () => {
  const [isSafariCookiePending, setIsSafariCookiePending] = useState(true);
  const [isIframeLoading, setIsIframeLoading] = useState(true);
  const isSafari = useIsSafari();
  const {
    data,
    isLoading: isSamlLoading,
    isError,
  } = useWhatAreYouAfraidOfSamlResponse();
  const samlResponse = data?.samlResponse;
  const isLoading = useMemo(
    () =>
      isSamlLoading ||
      (isIframeLoading && (!isSafari || !isSafariCookiePending)),
    [isSamlLoading, isIframeLoading, isSafari, isSafariCookiePending]
  );

  const onIframeLoad = useCallback(() => {
    setIsIframeLoading(false);
  }, [setIsIframeLoading]);

  const onAcceptSafariCookie = useCallback(() => {
    setIsSafariCookiePending(false);
    setIsIframeLoading(true);
  }, [setIsSafariCookiePending, setIsIframeLoading]);

  return (
    <>
      <LoadingIndicator
        className="absolute h-[calc(100%-12px)] w-full bg-white"
        isVisible={isLoading}
      />
      {isError && (
        <Typography variant="body" align="center">
          Sorry, there was an issue loading the content
        </Typography>
      )}
      {samlResponse && (
        <MGPIFrame
          samlResponse={samlResponse}
          onLoad={onIframeLoad}
          mgpSSOUrl={MGP_SSO_URL}
          mgpSafariCookieURL={MGP_SAFARI_COOKIE_FIX_URL}
          onSafariCookieAccepted={onAcceptSafariCookie}
          isSafari={isSafari}
          captureException={captureException}
          cookieConfirmationYOffset={0}
          renderCookieConfirmation={({ onAcceptCookie }) => (
            <SafariCookieConsent onAcceptCookie={onAcceptCookie} />
          )}
        />
      )}
    </>
  );
};

export default WhatAreYouAfraidOfSSO;
